// src/components/StockAlerts.js
// ─────────────────────────────────────────────────────────────
//  Stock alerts panel — shown in Vendor Admin page
//  Shows low-stock and out-of-stock items
//  Vendor can restock or mark resolved
// ─────────────────────────────────────────────────────────────

import React, { useState, useEffect } from 'react';
import api from '../services/api';

export default function StockAlerts({ vendorId, menu }) {
  const [alerts,   setAlerts]   = useState([]);
  const [updating, setUpdating] = useState(null);

  // Derive alerts from menu items (low stock + out of stock)
  useEffect(() => {
    if (!menu) return;
    const low = menu
      .filter((i) => i.stock <= (i.lowStockAt || 10))
      .map((i) => ({
        id:       i.id,
        itemName: i.name,
        stock:    i.stock,
        type:     i.stock === 0 ? 'out' : 'low',
      }));
    setAlerts(low);
  }, [menu]);

  const handleRestock = async (itemId, amount) => {
    setUpdating(itemId);
    try {
      await api.put(`/menu/${itemId}`, { stock: amount });
      setAlerts((a) => a.filter((x) => x.id !== itemId));
    } catch (_) {}
    setUpdating(null);
  };

  const handleToggle = async (itemId, currentActive) => {
    setUpdating(itemId);
    try {
      await api.patch(`/menu/${itemId}/toggle`);
    } catch (_) {}
    setUpdating(null);
  };

  if (alerts.length === 0) return (
    <div style={{
      padding:      '16px 20px',
      background:   '#1a3d2a',
      borderRadius: 10,
      border:       '1px solid var(--green)',
      fontSize:     13,
      color:        'var(--green)',
      fontWeight:   600,
    }}>
      ✅ All items well stocked
    </div>
  );

  return (
    <div style={{
      background:   'var(--bg2)',
      border:       '1px solid var(--border)',
      borderRadius: 'var(--radius)',
      overflow:     'hidden',
    }}>
      <div style={{
        padding:        '12px 16px',
        borderBottom:   '1px solid var(--border)',
        display:        'flex',
        alignItems:     'center',
        gap:            8,
        background:     '#3d1a00',
      }}>
        <span style={{ fontSize: 16 }}>⚠️</span>
        <span style={{ fontWeight: 700, color: 'var(--accent)' }}>
          Stock Alerts ({alerts.length})
        </span>
      </div>

      {alerts.map((alert) => (
        <div key={alert.id} style={{
          display:        'flex',
          alignItems:     'center',
          justifyContent: 'space-between',
          padding:        '12px 16px',
          borderBottom:   '1px solid var(--border)',
        }}>
          <div>
            <div style={{ fontWeight: 600, fontSize: 14 }}>
              {alert.type === 'out' ? '🔴' : '🟡'} {alert.itemName}
            </div>
            <div style={{ fontSize: 12, color: 'var(--text2)', marginTop: 2 }}>
              {alert.type === 'out' ? 'Out of stock' : `Low stock — ${alert.stock} remaining`}
            </div>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            {alert.type === 'out' ? (
              <button
                className="btn btn-ghost btn-sm"
                disabled={updating === alert.id}
                onClick={() => handleToggle(alert.id)}
              >
                Hide Item
              </button>
            ) : null}
            <button
              className="btn btn-primary btn-sm"
              disabled={updating === alert.id}
              onClick={() => handleRestock(alert.id, 100)}
            >
              {updating === alert.id ? '...' : '+ Restock'}
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
